// loading
export const SET_LOADINGSTATE = 'SET_LOADINGSTATE'

// goodsNavState
export const SET_GOODSNAVSTATE = 'SET_GOODSNAVSTATE'

/*
* prompt
*/
export const SET_PROMPTDATA = 'SET_PROMPTDATA'

export const SET_PROMPTSTATE = 'SET_PROMPTSTATE'

/*
* login
*/
export const SET_LOGINSTATE = 'SET_LOGINSTATE'

export const SETLOGINMODEL = 'SETLOGINMODEL'

// goodsDetails
export const SET_GOODSDETAILS = 'SET_GOODSDETAILS'

// shopDetails
export const SET_SHOPDETAILS = 'SET_SHOPDETAILS'

// orderType 
export const SET_ORDERTYPE = 'SET_ORDERTYPE'


// WEBPACK FOOTER //
// ./src/store/mutations-types.js